import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useNegotiation } from "../contexts/NegotiationContext";
import { Api } from "../services/Api";

function CartaoCreditoLinkDialog({ close }) {
  const { cartaoLinkID } = useNegotiation();
  const [status, setStatus] = useState("Consultando Status...");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const { data } = await Api.get(`/cartao/consulta_link/${cartaoLinkID}`);

        if (data === "aprovado") {
          setStatus("✅ Pagamento aprovado!");
          setDone(true);
          clearInterval(interval);
        } else if (data === "rejeitado") {
          setStatus("❌ Pagamento recusado.");
          setDone(true);
          clearInterval(interval);
        } else if (data === "autenticação pendente") {
          setStatus("⏳ Aguardando autenticação bancária, verifique o app do seu banco");
        } else {
          setStatus("⏳ Processando pagamento...");
        }
      } catch (err) {
        console.error(err);
        setStatus("Erro ao verificar status.");
        setDone(true);
        clearInterval(interval);
      }
    }, 3000); // consulta a cada 3s

    return () => clearInterval(interval);
  }, [cartaoLinkID]);

  return (
    <Dialog
      visible
      header="Pagamento em cartão"
      onHide={() => close()}
      style={{
        width: window.innerWidth > 820 ? "50vw" : "100vw",
        height: "auto",
        textAlign: "center",
        // borderRadius: '30px',
        // padding: '10px'
      }}
      draggable={false}
      className="boletosDialog"
    >
      <div className="flex flex-col items-center text-center">
        <h6>
          Seu pagamento será processado em outra aba, realiza o seu pagamento e retorne para ver o resultado do
          processamento
        </h6>
        <div className="p-1 lg:p-4 lg:my-2  text-left font-lato-bold border-sky-700 rounded-md border-2 bg-sky-100 grid">
          <h7>* A atualização do status de pagamento pode levar até 10 minutos para confirmação do pagamento</h7>
          <h7>
            * Durante esse período você pode sair desta página e voltar novamente mais tarde para verificar o status do
            seu pagamento
          </h7>
          <h7>
            * Caso não seja possível realizar o pagamento imediatamente, você pode consultar no botão abaixo "Minhas
            Negociações" o link de pagamento
          </h7>
          <h7>
            * Caso não consiga realizar o pagamento até a expiração do link a negociação será automaticamente revertida
            e será necessário realizar a negociação novamente
          </h7>
        </div>
        <h5 className="font-lato-bold ">
          Link do Pagamento:{" "}
          <a
            className="underline text-sky-700"
            href={`https://gateway.fixpay.com.br/payment/${cartaoLinkID}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Clique aqui
          </a>
        </h5>
        <h5 className="font-lato-bold">Status:</h5>
        <h5>{status}</h5>
        <button
          className="bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                    text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md mt-6"
          onClick={() => close()}
          disabled={!done}
        >
          Continuar
        </button>
      </div>
    </Dialog>
  );
}

export default CartaoCreditoLinkDialog;
